import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check, ArrowRight, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { SectionHeading } from "@/components/Section";

export default function Pricing() {
  const { t } = useI18n();
  const [services, setServices] = useState(null);

  useEffect(() => { api.get("/services").then((r) => setServices(r.data)).catch(() => setServices([])); }, []);

  return (
    <div className="section-lux grid-glow">
      <div className="container-lux">
        <SectionHeading label="Pricing" title="Transparent Pricing, Built Around Your Goals" subtitle="Every package is fully editable and priced in USDT. No hidden fees — only clear, honest pricing." />
        {services === null ? (
          <div className="flex justify-center py-20"><Loader2 className="animate-spin text-amber-400" size={36} /></div>
        ) : (
          <div className="mt-14 space-y-16">
            {services.map((s) => (
              <div key={s.id}>
                <div className="flex items-center justify-between mb-6">
                  <h3 className="text-xl font-bold text-white">{s.name}</h3>
                  <Link to={`/services/${s.slug}`} className="text-sm text-amber-400 hover:underline">{t("common.learnMore")}</Link>
                </div>
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                  {(s.packages?.length ? s.packages : [{ name: s.name, price: s.price, description: s.short_description }]).map((p, i) => (
                    <div key={i} className={`card-lux p-6 flex flex-col ${i === 1 ? "border-amber-500/50 shadow-[0_0_30px_rgba(212,175,55,0.12)]" : ""}`} data-testid={`price-card-${s.slug}-${i}`}>
                      {i === 1 && <div className="label-lux mb-2">Most Popular</div>}
                      <h4 className="font-semibold text-white">{p.name}</h4>
                      <div className="mt-3 font-display text-3xl font-extrabold text-white">{p.price} <span className="text-amber-400 text-lg">USDT</span></div>
                      {p.description && <p className="text-sm text-slate-400 mt-2 flex-1">{p.description}</p>}
                      <ul className="mt-4 space-y-2 flex-1">
                        {s.features?.slice(0, 4).map((f, j) => (
                          <li key={j} className="flex items-start gap-2 text-xs text-slate-400"><Check size={14} className="text-amber-400 mt-0.5" /> {f}</li>
                        ))}
                      </ul>
                      <Link to={`/services/${s.slug}`} className={`mt-5 ${i === 1 ? "gold-btn" : "silver-btn"} w-full text-sm`}>{t("common.orderNow")} <ArrowRight size={15} /></Link>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
